import { ExternalDataDTO } from "api/interfaces/external-data-dto";
import { getXMLDoc, getXMLNodeValue } from "@/utils";

export const mapFPAPResponseMapper = (xmlResponse: string, invoiceNumber: string): ExternalDataDTO => {
  const xmlDoc: Document = getXMLDoc(xmlResponse);
  const mappedFPResponse: ExternalDataDTO = {
    receiptIdentifier: {
      authorizationCode: getXMLNodeValue(xmlDoc, "authorizationCode") || ""
    },
    transactionIdentifier: {
      localRequestId: invoiceNumber,
      remoteRequestId: getXMLNodeValue(xmlDoc, "requestID") || "",
      merchantReferenceCode: getXMLNodeValue(xmlDoc, "merchantReferenceCode") || "",
      authorizationCode: getXMLNodeValue(xmlDoc, "authorizationCode") || "",
      originalTransactionType: "SALE",
      expirationDate: "",
      currentTotalAmount: getXMLNodeValue(xmlDoc, "amount") || "",
      accountToken: "",
      cardType: ""
    },
    transactionId: getXMLNodeValue(xmlDoc, "requestID") || ""
  };

  return mappedFPResponse;
};
